import type { Dict } from "../core.js";
import type { staff as vi } from "../vi/staff.js";

export const staff: Dict<typeof vi> = {
  loadFailed: "Couldn't load the staff list.",
  inviteFailed: "Couldn't create the account.",
  changeRoleFailed: "Couldn't change the role.",
  disableFailed: "Couldn't disable this staff member.",
  title: "Staff",
  intro: "The hub has no self-created accounts — every account is created here, and only owners can create them.",
  invite: "Create account",
  inviting: "Creating…",
  tempPasswordFor: "Temporary password for {email} — shown ONLY ONCE",
  tempPasswordHint: "Copy it now. The hub stores only a hash, so it can't be looked up again — if you lose it, issue a new one.",
  expiresAt: " Expires {at}.",
  copiedIt: "I've copied it",
  email: "Email",
  displayName: "Display name",
  role: "Role",
  "col.email": "Email",
  "col.name": "Name",
  "col.role": "Role",
  "col.membership": "Hub membership",
  "col.createdAt": "Created",
  cannotChangeOwnRole: "You can't change your own role",
  disableTitle: "Only revokes hub access — accounts in other apps are unaffected",
  disable: "Remove from hub",
  footnoteBefore: "« Remove from hub » only revokes membership in the hub's internal workspace. The shared identity (",
  footnoteMiddle: ") and accounts in other apps are ",
  footnoteStrong: "not",
  footnoteAfter: " touched.",
  "status.disabled": "Removed from hub",
  "status.mustChange": "Awaiting password change",
  "status.active": "Active",
};
